// No `toJSON()`: the archival endpoint carries no body.
class ArchiveDocumentType {
	constructor(
		public readonly accountId: number,
		public readonly documentTypeId: number,
	) {
		Object.freeze(this);
	}
}

export default ArchiveDocumentType;
